// extracted by mini-css-extract-plugin
module.exports = {"icon":"_88292","icon__initials":"_06d37","iconInitials":"_06d37"};